import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export const useTheme = () => useContext(ThemeContext);

// Storage keys bumped (-v2) so we ship a fresh light default to everyone.
const COLOR_KEY = "yk-color-v3";
const VARIANT_KEY = "yk-variant-v3";

export const ThemeProvider = ({ children }) => {
  const [colorMode, setColorMode] = useState(() => localStorage.getItem(COLOR_KEY) || "dark");
  const [variant, setVariant] = useState(() => localStorage.getItem(VARIANT_KEY) || "minimal");

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-mode", colorMode);
    root.setAttribute("data-variant", variant);
    root.classList.toggle("dark", colorMode === "dark");
    localStorage.setItem(COLOR_KEY, colorMode);
    localStorage.setItem(VARIANT_KEY, variant);
  }, [colorMode, variant]);

  const toggleColor = () => setColorMode((m) => (m === "dark" ? "light" : "dark"));
  const toggleVariant = () => setVariant((v) => (v === "minimal" ? "structural" : "minimal"));

  return (
    <ThemeContext.Provider value={{ colorMode, variant, setColorMode, setVariant, toggleColor, toggleVariant }}>
      {children}
    </ThemeContext.Provider>
  );
};
